import React from 'react';

import Tabs from 'components/Tabs';

class CareersPageJobBoardTabs extends React.Component {
  static get jobBoards() {
    return [
      {
        name: 'Headquarters',
        linkUrl: '/pages/careers',
      },
      {
        name: 'Retail Stores',
        linkUrl: '/pages/careers-retail',
      },
    ];
  }

  static get tabs() {
    return CareersPageJobBoardTabs.jobBoards.map(({ name }) => name);
  }

  static get linkUrls() {
    return CareersPageJobBoardTabs.jobBoards.map(({ linkUrl }) => linkUrl);
  }

  static get activeTabIndex() {
    return CareersPageJobBoardTabs.jobBoards.findIndex(
      jobBoard => window.location.pathname === jobBoard.linkUrl
    );
  }

  render() {
    return (
      <div className="CareersPageJobBoardTabs">
        <Tabs
          tabs={CareersPageJobBoardTabs.tabs}
          activeTabIndex={CareersPageJobBoardTabs.activeTabIndex}
          linkUrls={CareersPageJobBoardTabs.linkUrls}
          enableScrollTo={false}
        />
      </div>
    );
  }
}

export default CareersPageJobBoardTabs;
